<template>
  <!-- 公海全部线索列表 -->
  <div class="public-sea-clue-list" v-loading="loading">
    <!-- 筛选区域 -->
    <div class="filter-area">
      <div class="filter-item">
        <span class="filter-label">医生姓名</span>
        <el-input v-model="filterForm.doctorName" placeholder="搜索姓名" size="small" class="filter-input" />
      </div>
      <div class="filter-item">
        <span class="filter-label">坐诊医院</span>
        <el-input v-model="filterForm.hospital" placeholder="搜索医院" size="small" class="filter-input" />
      </div>
      <div class="filter-item">
        <span class="filter-label">上次跟进人</span>
        <el-select 
          v-model="filterForm.lastFollowUpPerson" 
          placeholder="请选择" 
          size="small" 
          class="filter-select"
          filterable
          remote
          :remote-method="searchEmployee"
          :loading="employeeSearchLoading"
        >
          <el-option 
            v-for="item in filteredEmployeeOptions" 
            :key="item.value" 
            :label="item.label" 
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <span class="filter-label">荣誉称号</span>
        <el-select 
          v-model="filterForm.honor" 
          multiple 
          filterable 
          placeholder="请选择" 
          size="small" 
          class="filter-select"
        >
          <el-option v-for="item in honorOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-btns">
        <el-button @click="resetHandle">重置</el-button>
        <el-button type="primary" @click="getTableData">查询</el-button>
      </div>
    </div>

    <!-- 子标签切换 -->
    <div class="sub-tabs">
      <span :class="{ active: activePool === 'push' }" @click="poolChangeHandle('push')">推进池({{ pageInfo.pushTotal || 0 }})</span>
      <span :class="{ active: activePool === 'incubate' }" @click="poolChangeHandle('incubate')">孵化池({{ pageInfo.incubateTotal || 0 }})</span>
    </div>

    <!-- 线索列表 -->
    <div class="table-area">
      <CustomTable
        :tableData="tableData"
        :column="roleType === 1 ? columns : columns.filter(item => item.prop !== 'operate')"
        max-height="450"
        border
        class="clue-table"
        :header-cell-style="headerCellStyle"
      >
        <template slot="nameCell" slot-scope="{ row }">
          <el-tag
            type="info"
            effect="plain"
            size="small"
            @click="showDoctorDetailHandle(row)"
          >{{ row.doctorName }}</el-tag>
        </template>
        <template slot="starCell" slot-scope="{ row }">
          <CustomStarText :saleStar="row.saleStar" :avgStar="row.avgStar" />
        </template>
        <template slot="operateCell" slot-scope="{ row }">
          <div class="operate-cell">
            <span class="operate-link" @click="transferHandle(row)">{{ operateText }}</span>
            <span v-if="activePool === 'push'" class="operate-link" @click="showPublicSeaClueAssignHandle(row)">由我分配</span>
          </div>
        </template>
      </CustomTable>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="activePool === 'push' ? pageInfo.pushTotal : pageInfo.incubateTotal"
        :page-size="pageInfo.pageSize"
        :current-page.sync="pageInfo.pageNum"
        @current-change="pageChangeHandle"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  name: 'PublicSeaClueList',
  data() {
    return {
      loading: false,
      activePool: 'push',
      filterForm: {
        doctorName: '',
        hospital: '',
        lastFollowUpPerson: '',
        honor: []  // 改为数组，支持多选
      },
      employeeOptions: [],
      filteredEmployeeOptions: [],
      employeeSearchLoading: false,
      honorOptions: [],
      pageInfo: {
        pushTotal: 0,
        incubateTotal: 0,
        pageSize: 20,
        pageNum: 1
      },
      // 推进池数据
      pushList: [],
      // 孵化池数据
      incubateList: [],
      columns: [
        { prop: 'doctorName', label: '医生', minWidth: '100', align: 'left', slotName: 'nameCell' },
        { prop: 'star', label: '星级', minWidth: '100', align: 'left', slotName: 'starCell' },
        { prop: 'monthSale', label: '月销售额', minWidth: '100', align: 'left' },
        { prop: 'avgVisitNum', label: '次均门诊量', minWidth: '100', align: 'left' },
        // { prop: 'clueSource', label: '线索来源', minWidth: '120', align: 'left' },
        { prop: 'approvalDate', label: '进入公海时间', minWidth: '160', align: 'left' },
        { prop: 'operate',  label: '操作', minWidth: '90', align: 'left', slotName: 'operateCell' }
      ]
    }
  },
  computed: {
    tableData() {
      return this.activePool === 'push' ? this.pushList : this.incubateList
    },
    operateText() {
      return this.activePool === 'push' ? '转孵化池' : '转推进池'
    }
  },
  created() {
    this.getTableData('push')
    this.getTableData('incubate')
    this.getEmployeeOptions()
    this.getHonorOptions()
  },
  methods: {
    headerCellStyle() {
      return { background: '#F7F8F9', color: '#667182', fontWeight: 500 }
    },
    poolChangeHandle(pool) {
      this.activePool = pool
      this.pageInfo.pageNum = 1
      this.pageInfo.total = pool === 'push' ? this.pushList.length : this.incubateList.length
      this.getTableData()
    },
    async getTableData(pool) {
      // 是否停止跟进
      const stopTrace = pool && typeof pool === 'string' ? pool !== 'push' : (this.activePool === 'push' ? false : true)
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        stopTrace,
        abList: this.filterForm.honor && this.filterForm.honor.length > 0 ? this.filterForm.honor : [],
        hospital: this.filterForm.hospital,
        lastWorkNumber: this.filterForm.lastFollowUpPerson,
        queryStr: this.filterForm.doctorName
      }
      try {
        this.loading = true
        const res = await request.post('/cluepool/pc/clue/publicList', params, '')
        if (res.code === 200) {
          const newData = (res.data.data || []).map(item => ({
            ...item,
            isPublicSea: true,
            approvalDate: item.approvalTime ? new Date(item.approvalTime).Format('yyyy-MM-dd') : '',
            receiveClewsText: item.receiveClews && item.receiveClews.length > 0 ? item.receiveClews.map(ite => ite.workName || '').join(',') : ''
          }))
          
          if (!stopTrace) {
            // 推进池
            this.pushList = newData
            this.pageInfo.pushTotal = res.data.totalElements || 0
          } else {
            // 孵化池
            this.incubateList = newData
            this.pageInfo.incubateTotal = res.data.totalElements || 0
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取公海列表请求失败', error)
      } finally {
        this.loading = false
      }
    },
    
    // 远程搜索员工
    searchEmployee(keyword) {
      if (keyword) {
        this.employeeSearchLoading = true
        // 模拟远程搜索延迟
        const resutKeyWord = keyword.toLowerCase()
        setTimeout(() => {
          this.filteredEmployeeOptions = this.employeeOptions.filter(item => 
            item.label.toString().toLowerCase().includes(resutKeyWord) || 
            item.value.toString().toLowerCase().includes(resutKeyWord)
          )
          this.employeeSearchLoading = false
        }, 300)
      } else {
        this.filteredEmployeeOptions = []
      }
    },

    // 获取员工选项
    async getEmployeeOptions() {
      try {
        const res = await request.get('/cluepool/pc/user/all', {}, '')
        if(res.code === 200) {
          this.employeeOptions = (res.data || []).map(item => ({
            label: item.nickName,
            value: item.workNumber
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('请求员工列表数据请求失败', error)
      }
    },

    // 获取荣誉称号选项
    async getHonorOptions() {
      const params = {
        questionCode: 'rych'
      }
      try {
        const res = await request.get('/cluepool/pc/admin/queryOption', params, '')
        if (res.code === 200) {
          this.honorOptions = (res.data || []).sort((a, b) => a.questionItemSort - b.questionItemSort).map(item => ({
            label: item.questionItemLabel,
            value: item.questionItemValue
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取线索列表选项失败', error)
      }
    },

    showDoctorDetailHandle(row) {
      this.$emit('showDoctorDetailHandle', row)
    },

    resetHandle() {
      this.filterForm = {
        doctorName: '',
        hospital: '',
        lastFollowUpPerson: '',
        honor: []  // 重置为空数组
      }
      this.getTableData()
    },

    pageChangeHandle(page) {
      this.pageInfo.pageNum = page
      this.getTableData()
    },

    // 转换线索
    transferHandle(row) {
      if (this.activePool === 'push') {
        this.$emit('transferIncubateHandle', row)
      } else {
        this.$emit('transferPushHandle', row)
      }
    },

    // 由我分配
    showPublicSeaClueAssignHandle(row) {
      this.$emit('showPublicSeaClueAssignHandle', row)
    }
  },
  props: {
    roleType: {
      type: [String, Number],
      default: ''
    }
  },
  components: {
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue'),
    CustomTable: () => import('@/components/CustomTable.vue')
  }
}
</script>

<style scoped lang="less">
.public-sea-clue-list {
  padding: 16px 20px;
}

// 筛选区域
.filter-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;

  .filter-item {
    display: flex;
    align-items: center;
    gap: 8px;

    .filter-label {
      font-size: 13px;
      color: #1F2329;
      flex-shrink: 0;
    }

    .filter-input {
      width: 140px;
    }

    .filter-select {
      width: 120px;
    }
  }
}

// 子标签
.sub-tabs {
  display: flex;
  margin-bottom: 16px;
  width: fit-content;
  background-color: #F7F8F9;
  border-radius: 4px;
  border: 1px solid #E0E0E0;
  overflow: hidden;

  span {
    padding: 6px 12px 7px;
    font-size: 13px;
    color: #667182;
    cursor: pointer;
    transition: all 0.2s;

    &.active {
      background-color: #1890FF;
      color: #fff;
      font-weight: 500;
    }
  }
}

// 表格区域
.table-area {
  .clue-table {
    /deep/ .el-table {
      font-size: 13px;
      color: #1F2329;
      border-color: #EBEAEE;

      &::before,
      &::after {
        background-color: #EBEAEE;
      }

      th {
        padding: 0 !important;
        height: 40px;
      }

      td {
        padding: 0 !important;
        height: 44px;
      }

      .cell {
        line-height: 20px;
      }
    }

    /deep/ .el-tag--plain.el-tag--info {
      background-color: #F7F8F9;
      border-color: #EBEAEE;
      color: #667182;
      height: 24px;
      line-height: 22px;
      padding: 0 10px;
      border-radius: 12px;
      font-size: 12px;
      cursor: pointer;

      &:hover {
        border-color: #1890FF;
        color: #1890FF;
      }
    }

    .operate-cell {
      display: flex;
      align-items: center;
      gap: 12px;

      .operate-link {
        font-size: 13px;
        color: #1890FF;
        cursor: pointer;

        &:hover {
          color: #40A9FF;
        }
      }
    }
  }
}

// 分页
.pagination-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>